export default {
    label: 'Evaluation criteria',
    placeholder: 'Select evaluation criteria',
    description:
    'Select the criteria for the trend evaluation. ' +
    'You cannot change the criteria once a trend evaluation is available.'
}
